export const IS_ADMIN_LOGIN = "admin.login";
export const ADMIN_LOGIN_EMAIL = "admin.email";
export const ADMIN_LOGIN_RUNNER_ID = "admin.asRunnerId";
